import { Component, Input, OnInit } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';
import { map } from 'rxjs/operators';
import { table } from 'console';

@Component({
  selector: 'lifedi-profile-informant',
  templateUrl: './profile-informant.component.html',
  styleUrls: ['./profile-informant.component.scss']
})
export class ProfileInformantComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;

  isLoading: boolean;

  data_report;

  constructor(
    private measureService: MeasureService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;

    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.getReport(body);

  }

  getReport(body) {
    this.measureService.getReportByMeasureId(body).pipe(
      map((res) => {
        this.data_report = [res.result];
        console.log(this.data_report);
        setTimeout(() => {
          this.filepdf('email');
        }, 1000);
        this.isLoading = false;
      })
    )
      .subscribe();
  }


  filepdf(transfer) {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let alldata = this.data_report;
    let NewArray = [];
    for (let i = 0; i < alldata[0].data.length; i++) {
      let a = document.getElementById('sliderpdf' + i);
      NewArray.push(a);
    }
    for (let i = 0; i < alldata[0].data2.length; i++) {
      let b = document.getElementById('sliderpdfInformant' + i);
      NewArray.push(b);
    }
    console.log(NewArray);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        console.log(dataArray);
        let half = Math.ceil(dataArray.length / 2); // หาครึ่งที่สูงกว่า
        let firstHalf = dataArray.splice(0, half);
        let secondHalf = dataArray;

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 20,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 18,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [100],
                heights: [-3],
                body: [
                  [
                    {
                      text: 'ผู้ทำแบบทดสอบ',
                      fontSize: 15,
                      bold: true,
                      aligment: 'center',
                      fillColor: '#060e9f',
                      border: [true, true, true, true],
                      color: '#ffffff',
                      alignment: 'center',
                      margin: [0, 0],
                      borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                    }
                  ]
                ]
              }
            },
            {
              text: this.data_report[0].data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[0].COLOR_CODE,
              margin: [0, 20, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: '',
            },
            {
              text: this.data_report[0].data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: firstHalf[0],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, 10, 10, 0],
                },
                {
                  columns: [
                    [
                      {
                        text:
                          'คะแนนต่ำสุด : ' +
                          this.data_report[0].data[0].min +
                          '    คะแนนสูงสุด : ' +
                          this.data_report[0].data[0].max,
                        width: '*',
                        color: '#000000',
                        fontSize: 16,
                        bold: true,
                      },
                      {
                        text:
                          'ท่านได้ ' +
                          parseFloat(this.data_report[0].data[0].slider_value).toFixed(2) +
                          ' คะแนน',
                        // ' อยู่ในช่วงคะแนน ' +
                        // this.data_report[0].data[0].range +
                        // ' คะแนน',
                        width: '*',
                        color: this.data_report[0].data[0].COLOR_CODE,
                        margin: [0, 0, 0, 0],
                        fontSize: 16,
                        bold: true,
                      },
                    ]
                  ]
                },
              ],
            },
            {
              text: this.data_report[0].data[0].range_description,
              width: 200,
              fontSize: 14,
              margin: [0, -50, 0, 50],
            },
          ],
          defaultStyle: {
            columnGap: 20,
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < this.data_report[0].data.length; i++) {
          let after = '';
          // if (i % 3 == 0) {
          //   after = 'before';
          // }

          allPage.content.push(
            {
              text: this.data_report[0].data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[i].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: after,
            },
            {
              text: this.data_report[0].data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: firstHalf[i],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, 10, 10, 0],
                },
                {
                  columns: [
                    [
                      {
                        text:
                          'คะแนนต่ำสุด : ' +
                          this.data_report[0].data[i].min +
                          '    คะแนนสูงสุด : ' +
                          this.data_report[0].data[i].max,
                        width: '*',
                        color: '#000000',
                        fontSize: 16,
                        bold: true,
                      },
                      {
                        text:
                          'ท่านได้ ' +
                          parseFloat(this.data_report[0].data[i].slider_value).toFixed(2) +
                          ' คะแนน',
                        // ' อยู่ในช่วงคะแนน ' +
                        // this.data_report[0].data[i].range +
                        // ' คะแนน',
                        width: '*',
                        color: this.data_report[0].data[i].COLOR_CODE,
                        margin: [0, 0, 0, 0],
                        fontSize: 16,
                        bold: true,
                      },
                    ],
                  ]
                },
              ],
            },
            {
              text: this.data_report[0].data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 50],
            },
          );
        }

        allPage.content.push(
          {
            text: '',
            alignment: 'left',
            decoration: 'underline',
            color: '#fff',
            margin: [0, 0, 0, 5],
            width: 'auto',
            fontSize: 18,
            bold: true,
            pageBreak: 'after',
          },
          {
            text: '',
            width: '*',
            fontSize: 14,
            margin: [0, 0, 0, 5],
          },
          {
            table: {
              headerRows: 1,
              widths: [120],
              heights: [-5],
              body: [
                [
                  {
                    text: 'ผู้มีส่วนร่วมในแบบทดสอบนี้',
                    fontSize: 15,
                    bold: true,
                    aligment: 'center',
                    fillColor: '#060e9f',
                    border: [true, true, true, true],
                    color: '#ffffff',
                    alignment: 'center',
                    margin: [0, 0],
                    borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                  }
                ]
              ]
            }
          },
          {
            text: '',
            width: '*',
            fontSize: 14,
            margin: [0, 0, 0, 10],
          },
        )

        let parances = [];
        this.data_report[0].parances.forEach(e => {
          parances.push(`${e.EMAIL} (${e.TAG})`)
        });
        let parancesStr = (parances.join()).replace(/,/g, ', ')

        allPage.content.push(
          {
            text: 'รายงานผลของผู้มีส่วนร่วมนี้เป็นของ',
            alignment: 'left',
            decoration: '',
            color: '#000',
            margin: [0, 20, 0, 8],
            width: 'auto',
            fontSize: 16,
            bold: true,
            pageBreak: '',
          },
          {
            text: parancesStr,
            width: '*',
            fontSize: 15,
            margin: [0, 0, 0, 25],
          },
        )

        for (let i = 0; i < this.data_report[0].data2.length; i++) {
          let after = '';
          // if (i !== 0 && i % 3 == 0) {
          //   after = 'before';
          // }

          allPage.content.push(
            {
              text: this.data_report[0].data2[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data2[i].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: after,
            },
            {
              text: this.data_report[0].data2[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: secondHalf[i],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, 10, 10, 0],
                },
                {
                  columns: [
                    [
                      {
                        text:
                          'คะแนนต่ำสุด : ' +
                          this.data_report[0].data2[i].min +
                          '    คะแนนสูงสุด : ' +
                          this.data_report[0].data2[i].max,
                        width: '*',
                        color: '#000000',
                        fontSize: 16,
                        bold: true,
                      },
                      {
                        text:
                          'ท่านได้ ' +
                          parseFloat(this.data_report[0].data2[i].slider_value).toFixed(2) +
                          ' คะแนน',
                        // ' อยู่ในช่วงคะแนน ' +
                        // this.data_report[0].data2[i].range +
                        // ' คะแนน',
                        width: '*',
                        color: this.data_report[0].data2[i].COLOR_CODE,
                        margin: [0, 0, 0, 0],
                        fontSize: 16,
                        bold: true,
                      },
                    ],
                  ]
                }
              ],
            },
            {
              text: this.data_report[0].data2[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 50],
            },
          );
        }

        if (transfer === 'email') {
          let pdfDocGenerator = pdfMake.createPdf(allPage);
          pdfDocGenerator.getBase64((base64str) => {
            // console.log(base64str);
            let data = {
              MEASURE_ID: this.measureid,
              TYPE: this.type,
              base64str: base64str,
              view: this.view_status,
            };
            this.measureService.SaveReportMeasureId(data).subscribe((res) => {
              // console.log(res);
            });
          });
        } else if (transfer === 'download') {
          pdfMake.createPdf(allPage).open();
        }
      }
    );
  }

}
